import { render, staticRenderFns } from "./InputCommentaireComponent.vue?vue&type=template&id=34098677"
import script from "./InputCommentaireComponent.vue?vue&type=script&lang=js"
export * from "./InputCommentaireComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports